import React, { useCallback, useEffect, useState } from 'react'
import Button from '../../../../ui/Button/Button'
import getTurboSmsBalance from '../../../../api/sms/getTurboSmsBalance'
import { formatSmsTimestamp, formatTurboSmsBalance } from './smsUiUtils'
import './Sms.sass'

function SmsBalance() {
  const [balance, setBalance] = useState(null)
  const [updatedAt, setUpdatedAt] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const loadBalance = useCallback(async () => {
    setIsLoading(true)
    setError('')

    const result = await getTurboSmsBalance()
    if (!result.ok) {
      setError(result.message || 'Не вдалося отримати баланс TurboSMS')
      setIsLoading(false)
      return
    }

    const nextBalance = result.data?.balance
    if (nextBalance == null || !Number.isFinite(Number(nextBalance))) {
      setError('TurboSMS не повернув баланс')
      setIsLoading(false)
      return
    }

    setBalance(Number(nextBalance))
    setUpdatedAt(Date.now())
    setIsLoading(false)
  }, [])

  useEffect(() => {
    loadBalance()
  }, [loadBalance])

  return (
    <div className="SmsBalance">
      <span className="SmsBalance-Label">Баланс TurboSMS:</span>
      <span className="SmsBalance-Value">
        {isLoading && balance == null ? '…' : formatTurboSmsBalance(balance)}
      </span>
      {updatedAt != null ? (
        <span className="SmsBalance-Updated">· Оновлено: {formatSmsTimestamp(updatedAt)}</span>
      ) : null}
      <Button
        theme="circle"
        fill="white"
        color={isLoading ? 'white' : 'accent'}
        icon="sync"
        className="SmsBalance-Refresh"
        tooltip="Оновити баланс"
        isLoading={isLoading}
        onClick={loadBalance}
      />
      {error ? <span className="SmsBalance-Error">{error}</span> : null}
    </div>
  )
}

export default SmsBalance
